import {NgModule} from "@angular/core";
import { CommonModule } from '@angular/common';

import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {MatTooltipModule} from '@angular/material/tooltip';
import {IboxtoolsComponent} from "./iboxtools.component";
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputNumericComponent } from '../input-numeric/input-numeric.component';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [IboxtoolsComponent, InputNumericComponent
  ],
  imports     : [ CommonModule, 
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
                  DialogModule,
                  ButtonModule,
    BsDropdownModule.forRoot(),
    SharedModule
                ],
  exports     : [
    IboxtoolsComponent,
    InputNumericComponent
                ],  
})

export class IboxtoolsModule {}
